import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createBlock as _createBlock, createVNode as _createVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_SignatureItem = _resolveComponent("SignatureItem");
    const _component_VerifySignature = _resolveComponent("VerifySignature");
    const _component_FriedModal = _resolveComponent("FriedModal");
    const _component_EditorNodeWrapper = _resolveComponent("EditorNodeWrapper");
    return (_openBlock(), _createBlock(_component_EditorNodeWrapper, {
        class: _normalizeClass([
            'node-container',
            'signature-container view',
            _ctx.rowTypeClass,
            _ctx.blockWidthClass,
            {
                'parent-first-child': _ctx.parentFirstChild,
                'parent-last-child': _ctx.parentLastChild,
                'empty-signature-container': _ctx.getVisibleSignatures.length === 0,
            },
        ]),
        "data-external": "editor-view-signature-element-container",
        onObserveNodeVisibility: _cache[3] || (_cache[3] = ($event) => (_ctx.$emit('observe-node-visibility', Object.assign(Object.assign({}, $event), { nodeId: _ctx.node.id }))))
    }, {
        default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getVisibleSignatures, (signature, index) => {
                return (_openBlock(), _createBlock(_component_SignatureItem, {
                    id: signature.id,
                    key: signature.id,
                    signature: signature,
                    node: _ctx.node,
                    sender: _ctx.sender,
                    "is-loading-signature": _ctx.isLoadingSignature,
                    recipient: _ctx.recipient,
                    "focused-required-id": _ctx.focusedRequiredId,
                    "partially-signed-fields": _ctx.partiallySignedFields,
                    context: _ctx.context,
                    "is-pdf-viewer": _ctx.isPdfViewer,
                    "data-external": `edit-signature-${index}`,
                    class: _normalizeClass([_ctx.blockWidthClass, 'signature-content']),
                    "merge-values": _ctx.mergeValues,
                    onOpenSignatureModal: _ctx.handleShowSignatureModal,
                    onUpdateLoadingSignature: _cache[0] || (_cache[0] = ($event) => (_ctx.isLoadingSignature = false))
                }, null, 8, ["id", "signature", "node", "sender", "is-loading-signature", "recipient", "focused-required-id", "partially-signed-fields", "context", "is-pdf-viewer", "data-external", "class", "merge-values", "onOpenSignatureModal"]));
            }), 128)),
            (_ctx.showSignatureModal)
                ? (_openBlock(), _createBlock(_component_FriedModal, {
                    key: 0,
                    closable: true,
                    size: _ctx.ModalSize.Large,
                    onClose: _cache[2] || (_cache[2] = ($event) => (_ctx.showSignatureModal = false))
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_VerifySignature, {
                            recipient: _ctx.recipient,
                            entity: _ctx.mergeValues.entity,
                            "document-name": _ctx.mergeValues.document.name,
                            "in-editor": true,
                            onSign: _ctx.handleVerifySignature,
                            onCancel: _cache[1] || (_cache[1] = ($event) => (_ctx.showSignatureModal = false))
                        }, null, 8, ["recipient", "entity", "document-name", "onSign"])
                    ]),
                    _: 1
                }, 8, ["size"]))
                : _createCommentVNode("", true)
        ]),
        _: 1
    }, 8, ["class"]));
}
